<template>
  <div>
    <section class="hero is-fullheight">
      <div class="hero-body is-primary" >
        <div class="container has-text-centered">
          <h1 class="subtitle is-1 is-hidden-mobile">¡IMPRIMÍ DESDE CASA!</h1>
          <h1 class="subtitle is-3 is-hidden-tablet">¡IMPRIMÍ<br>DESDE CASA!</h1>
          <b-button class="boton-productos" type="is-primary" size="is-large"
          v-scroll-to="'#seccion-productos'"
          >¡VER PRODUCTOS!</b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@keyframes kreep {
    0% {-webkit-transform: scale(1.1,.9);
        transform: scale(1.1,.9);}
   50% { -webkit-transform: scale(.9,1.1) translateY(-.5rem)}
   70% { -webkit-transform: scale(1);
         transform: scale(1);}
}

.boton-productos {
  margin: 0.3rem;
  display: inline-block;
  /*name-duration-function(ease,eas-in,linear)-delay-count-direction */
  animation: kreep 0.7s ease 0s infinite alternate;
}
.boton-productos:hover {
  animation: none;
}

.hero {
  background-image: url('~@/assets/img/portada.jpg');
  background: linear-gradient(rgba(31, 44, 108, 0), rgba(31, 44, 108, 0)), rgba(0, 0, 0, 0) url("~@/assets/img/portada.jpg") no-repeat;
  background-attachment: fixed;
  background-size: cover;
  // background-position: center;
  background-position-x: 50%; // Solucion para ios en vez de background-position: center
  background-position-y: 0%; // Solucion para ios en vez de background-position: center
}

</style>

<script>
import SelectorTipoProducto from '@/components/SelectorTipoProducto'

export default {
  name: 'Hero',
  methods: {
    lanzarModalSelectorProducto () {
      this.showNavBurger = false
      this.$buefy.modal.open({
        parent: this,
        component: SelectorTipoProducto,
        trapFocus: true
      })
    }
  }
}
</script>
